import { ROLES, type UserRole } from '../constants';

/**
 * Whether a user with `userRole` may open what `roles` allow. Everyone may when there are no
 * roles, and when editors are among them.
 */
export const isAuthorized = (userRole: UserRole | null, roles: UserRole[] | undefined) =>
    !roles || (userRole !== null && roles.includes(userRole)) || roles.includes(ROLES.EDITOR);
